import { render, staticRenderFns } from "./BracketSeparator.vue?vue&type=template&id=2fe8f790&scoped=true&"
import script from "./BracketSeparator.vue?vue&type=script&lang=ts&"
export * from "./BracketSeparator.vue?vue&type=script&lang=ts&"
import style0 from "./BracketSeparator.vue?vue&type=style&index=0&id=2fe8f790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8f790",
  null
  
)

export default component.exports